/**
 * FlowGuide — sagt oben im Editor, woraus ein Flow besteht und wo man was ändert.
 *
 * Der Editor hatte vierzehn gleich aussehende Abschnitte und rund 130 Felder,
 * ohne einen Satz darüber, welche davon zusammengehören. BA dazu: „das war sehr
 * unübersichtlich, ich habe das selbst nicht durchgeblickt." Die Info-Popover an
 * den einzelnen Feldern erklären jedes für sich — was fehlte, ist die Ebene
 * darüber: WAS muss geändert werden, WO, und was gehört überhaupt zusammen.
 *
 * Drei Sätze, keine Bedienungsanleitung. Wer mehr will, klickt die ⓘ am Feld.
 */
export function FlowGuide({ matlabSource }) {
  return (
    <section className="admin-flow-guide">
      <h3 className="admin-flow-guide__title">Woraus dieser Flow besteht</h3>
      <ol className="admin-flow-guide__list">
        <li>
          <strong>Die Zahlen — aus dem MATLAB-Skript.</strong> Filter, Gewichte,
          Deratings, Wirkungsgrade, Zielwerte.{' '}
          {matlabSource ? (
            <>
              Kommen aus <code>{matlabSource.file}</code> und sind hier{' '}
              <em>gesperrt</em>. Ändern heißt: im Skript ändern, dann oben{' '}
              <strong>Import from MATLAB</strong> — einfügen, Diff prüfen,
              übernehmen.
            </>
          ) : (
            <>
              Noch kein Skript importiert. Sobald eines importiert ist, werden
              diese Felder gesperrt und nur noch über den Import geändert.
            </>
          )}
        </li>
        <li>
          <strong>Der Dialog — unserer.</strong> Einleitung, Fragen und
          Abwägungsfragen. Das Skript kennt keinen Dialog, also wird hier
          geschrieben: Formulierung, Reihenfolge, Antwortmöglichkeiten.
        </li>
        <li>
          <strong>Der Rest ist selten.</strong> Plot-Achsen, Hinweise, Report,
          Gewichts-Regeln — zusammengeklappt, weil man sie fast nie anfasst.
        </li>
      </ol>
      <p className="admin-flow-guide__rule">
        Eine Regel, die häufig überrascht: <strong>ein Zielwert wirkt nur, wenn
        eine Frage darauf zeigt.</strong> Steht bei einer Frage unter „Antwort
        setzt" nichts, wird der zugehörige Wert beim Ranking nicht angewandt —
        auch wenn er unter „Defaults" steht.
      </p>
    </section>
  )
}
